<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-112"
    customWidth="lg:w-120"
  >
    <template #modal-header>
      <div class="">
        <div class="flex items-center">
          <Icon name="Trash2" class="w-4 h-4 mr-1 stroke-error" />
          <div class="text-sm font-inter font-semibold text-error">Delete</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Delete Document
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-6 text-lg flex flex-col gap-3 text-center">
        <div class="text-error">"{{ props.modal_config.record.file_name }}"</div>
        <div class="text-strongest">
          You are choosing to permanently delete the document. This action cannot be undone. Are you
          sure you want to proceed?
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>Confirm</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
// IMPORTS
import { Modal, Icon, Button } from "@/components";
import { useCrudStore, useUIStore } from "@/stores";

//STORES
const crudStore = useCrudStore();
const UIStore = useUIStore();

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "refresh"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  try {
    let doc = props.modal_config.record;

    if (!doc || !doc.record_id) {
      throw new Error("Invalid document record. Cannot delete.");
    }
    let delete_query = [
      {
        field_name: "record_id",
        operator: "eq",
        value: doc.record_id,
      },
    ];

    await crudStore.delete("documents", delete_query);

    emit("refresh");
    emit("close-modal");
  } catch (error) {
    var alert = {
      type: "error",
      message: `Failed to delete document.`,
    };
    UIStore.animateNotificationAlert(alert);
    emit("close-modal");
  }
}
</script>
